import type { EdgeTypes } from "@xyflow/react";
import { ExpressionEdge } from "./ExpressionEdge";

export const edgeTypes: EdgeTypes = {
  expression: ExpressionEdge,
};

export { ExpressionEdge };
